import React, { useState } from "react";
import StepOne from "./StepOne";
import StepThree from "./StepThree";
import StepTwo from "./StepTwo";
import StepFour from "./StepFour";
import { useNavigate, useLocation } from "react-router-dom";

const MultistepForm = () => {
  const location = useLocation();
  let step = 1;
  // if (location.state != undefined && location.state != null) {
  //   step = Number(location.state.row.step == 1)
  //     ? 2
  //     : Number(location.state.row.step == 2)
  //     ? 3
  //     : Number(location.state.row.step == 3)
  //     ? 4
  //     : 1;
  // }

  if (location.state != undefined && location.state != null) {

     console.log("location.state.record_id", location.state)
     if(![undefined,null,""].includes(location.state.record_id)){
     step = 1
     }else{
    step = Number(location.state.row.step == 1)
      ? 2
      : Number(location.state.row.step == 2)
      ? 4
      : Number(location.state.row.step == 3)
      ? 4
      : 1;
     }


  }

  const [currentStep, setCurrentStep] = useState(step);
  const [formData, setFormData] = useState({});

  const nextStep = (isPackageSelected ,extraData) => {
    setFormData({...formData,...extraData})
    if (isPackageSelected == false) {
      setCurrentStep(currentStep + 2);
    } else if (
      isPackageSelected == undefined ||
      isPackageSelected == null ||
      isPackageSelected == true
    ) {
      setCurrentStep(currentStep + 1);
    } else {
      setCurrentStep(currentStep + 1);
    }
  };

  const prevStep = (isPackageSelected) => {
    if (isPackageSelected == false) {
      setCurrentStep(currentStep - 2);
    } else if (
      isPackageSelected == undefined ||
      isPackageSelected == null ||
      isPackageSelected == true
    ) {
      setCurrentStep(currentStep - 1);
    } else {
      setCurrentStep(currentStep - 1);
    }
  };



  
 

  const handleChange = (input) => (e) => {
    setFormData({ ...formData, [input]: e.target.value });
  };

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <StepOne
            formData={formData}
            handleChange={handleChange}
            nextStep={nextStep}
            prevStep={prevStep}
            currentStep={currentStep}
          />
        );
      case 2:
        return (
          <StepTwo
            formData={formData}
            handleChange={handleChange}
            nextStep={nextStep}
            prevStep={prevStep}
            currentStep={currentStep}
          />
        );
      case 3:
        return (
          <StepThree
            formData={formData}
            handleChange={handleChange}
            nextStep={nextStep}
            prevStep={prevStep}
            currentStep={currentStep}
          />
        );
      case 4:
        return (
          <StepFour
            formData1={formData}
            handleChange={handleChange}
            nextStep={nextStep}
            prevStep={prevStep}
            currentStep={currentStep}
          />
        );
      default:
        return null;
    }
  };

  // return (
  //   <div className="">
  //     <div className="card p-4">
  //       <form>
  //         <div className="row">
  //           <div className="col-md-6">
  //             <label className="col-form-label">
  //               Select Service type for Quote
  //             </label>
  //           </div>
  //           <div className="col-md-6">
  //             <select className="form-select">
  //               <option value="1">Service 1</option>
  //               <option value="2">Service 2</option>
  //             </select>
  //           </div>
  //         </div>
  //         <label className="col-form-label">Quires type</label>
  //         <div className="gray-card">
  //           <div className="card-body">
  //             <div className="row">
  //               <div className="col-md-6 pe-lg-5">
  //                 <label className="col-form-label">
  //                   1. What's your Turn Over?
  //                 </label>
  //                 <input type="text" className="form-control"></input>
  //               </div>

  //               <div className="col-md-6 ps-lg-5">
  //                 <label className="col-form-label">
  //                   2. How many Transaction's do you want?
  //                 </label>
  //                 <input type="text" className="form-control"></input>
  //               </div>
  //             </div>
  //             <div className="row mt-3 align-items-center">
  //               <div className="col-md-6 pe-lg-5">
  //                 <label className="col-form-label">
  //                   3. How many Subcontractors do you have?
  //                 </label>
  //                 <input type="text" className="form-control"></input>
  //               </div>

  //               <div className="col-md-6  ps-lg-5">
  //                 <div className="d-flex">
  //                   <label className="col-form-label c pt-0">
  //                     4. Do you need Self-Assessments?
  //                   </label>
  //                   <div className="ms-3">
  //                     <div className="form-check">
  //                       <input
  //                         className="form-check-input"
  //                         type="radio"
  //                         name="gridRadios"
  //                         id="gridRadios1"
  //                         defaultValue="option1"
  //                       />
  //                       <label
  //                         className="form-check-label"
  //                         htmlFor="gridRadios1"
  //                       >
  //                         Yes
  //                       </label>
  //                     </div>
  //                   </div>
  //                   <div className="ms-3">
  //                     <div className="form-check">
  //                       <input
  //                         className="form-check-input"
  //                         type="radio"
  //                         name="gridRadios"
  //                         id="gridRadios1"
  //                         defaultValue="option1"
  //                       />
  //                       <label
  //                         className="form-check-label"
  //                         htmlFor="gridRadios1"
  //                       >
  //                         No
  //                       </label>
  //                     </div>
  //                   </div>
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //         <div className="card mt-4 shadow-none">
  //           <div className="card-body">
  //             <div className="row  align-items-center">
  //               <div className="col-md-6 pe-lg-5">
  //                 <div className="d-flex">
  //                   <label className="col-form-label w-50">Package Type</label>
  //                   <select className="form-select">
  //                     <option value="1">Service 1</option>
  //                     <option value="2">Service 2</option>
  //                   </select>
  //                 </div>
  //               </div>

  //               <div className="col-md-6  ps-lg-5">
  //                 <div className="d-flex">
  //                   <div className="w-100">
  //                     <input
  //                       className="form-control"
  //                       type="search"
  //                       placeholder="Search Services"
  //                     />
  //                   </div>
  //                 </div>
  //               </div>
  //             </div>
  //             <div className="row  align-items-center mt-3">
  //               <div className="col-md-6 pe-lg-5">
  //                 <div className="d-flex">
  //                   <label className="col-form-label c pt-0">
  //                     Show Discount
  //                   </label>
  //                   <div className="ms-3">
  //                     <div className="form-check">
  //                       <input
  //                         className="form-check-input"
  //                         type="radio"
  //                         name="gridRadios"
  //                         id="gridRadios1"
  //                         defaultValue="option1"
  //                       />
  //                       <label
  //                         className="form-check-label"
  //                         htmlFor="gridRadios1"
  //                       >
  //                         Yes
  //                       </label>
  //                     </div>
  //                   </div>
  //                   <div className="ms-3">
  //                     <div className="form-check">
  //                       <input
  //                         className="form-check-input"
  //                         type="radio"
  //                         name="gridRadios"
  //                         id="gridRadios1"
  //                         defaultValue="option1"
  //                       />
  //                       <label
  //                         className="form-check-label"
  //                         htmlFor="gridRadios1"
  //                       >
  //                         No
  //                       </label>
  //                     </div>
  //                   </div>
  //                 </div>
  //               </div>

  //               <div className="col-md-6  ps-lg-5">
  //                 <div className="d-flex">
  //                   <label className="col-form-label c pt-0">Show Price</label>
  //                   <div className="ms-3">
  //                     <div className="form-check">
  //                       <input
  //                         className="form-check-input"
  //                         type="radio"
  //                         name="gridRadios"
  //                         id="gridRadios1"
  //                         defaultValue="option1"
  //                       />
  //                       <label
  //                         className="form-check-label"
  //                         htmlFor="gridRadios1"
  //                       >
  //                         Yes
  //                       </label>
  //                     </div>
  //                   </div>
  //                   <div className="ms-3">
  //                     <div className="form-check">
  //                       <input
  //                         className="form-check-input"
  //                         type="radio"
  //                         name="gridRadios"
  //                         id="gridRadios1"
  //                         defaultValue="option1"
  //                       />
  //                       <label
  //                         className="form-check-label"
  //                         htmlFor="gridRadios1"
  //                       >
  //                         No
  //                       </label>
  //                     </div>
  //                   </div>
  //                 </div>
  //               </div>
  //             </div>

  //             <div className="table-resposnsive">
  //               <table className="table  border">
  //                 <thead>
  //                   <tr>
  //                     <td
  //                       style={{
  //                         background: "#F5F5F5",
  //                         color: "#4E4E4E",
  //                         fontSize: "14px",
  //                       }}
  //                     >
  //                       Quires
  //                     </td>
  //                     <td
  //                       style={{
  //                         background: "#F5F5F5",
  //                         color: "#4E4E4E",
  //                         fontSize: "14px",
  //                       }}
  //                     >
  //                       Individual 1
  //                     </td>
  //                     <td
  //                       style={{
  //                         background: "#F5F5F5",
  //                         color: "#4E4E4E",
  //                         fontSize: "14px",
  //                       }}
  //                     >
  //                       Individual 2
  //                     </td>
  //                   </tr>
  //                 </thead>
  //                 <tbody>
  //                   <tr>
  //                     <td className="fs-14">Do you have UK Wages Income?</td>
  //                     <td className="fs-14">
  //                       <div className="d-flex">
  //                         <div className="">
  //                           <div className="form-check">
  //                             <input
  //                               className="form-check-input"
  //                               type="radio"
  //                               name="gridRadios"
  //                               id="gridRadios1"
  //                               defaultValue="option1"
  //                             />
  //                             <label
  //                               className="form-check-label"
  //                               htmlFor="gridRadios1"
  //                             >
  //                               Yes
  //                             </label>
  //                           </div>
  //                         </div>
  //                         <div className="ms-3">
  //                           <div className="form-check">
  //                             <input
  //                               className="form-check-input"
  //                               type="radio"
  //                               name="gridRadios"
  //                               id="gridRadios1"
  //                               defaultValue="option1"
  //                             />
  //                             <label
  //                               className="form-check-label"
  //                               htmlFor="gridRadios1"
  //                             >
  //                               No
  //                             </label>
  //                           </div>
  //                         </div>
  //                       </div>
  //                     </td>
  //                     <td className="fs-14">
  //                       <div className="d-flex">
  //                         <div className="">
  //                           <div className="form-check">
  //                             <input
  //                               className="form-check-input"
  //                               type="radio"
  //                               name="gridRadios"
  //                               id="gridRadios1"
  //                               defaultValue="option1"
  //                             />
  //                             <label
  //                               className="form-check-label"
  //                               htmlFor="gridRadios1"
  //                             >
  //                               Yes
  //                             </label>
  //                           </div>
  //                         </div>
  //                         <div className="ms-3">
  //                           <div className="form-check">
  //                             <input
  //                               className="form-check-input"
  //                               type="radio"
  //                               name="gridRadios"
  //                               id="gridRadios1"
  //                               defaultValue="option1"
  //                             />
  //                             <label
  //                               className="form-check-label"
  //                               htmlFor="gridRadios1"
  //                             >
  //                               No
  //                             </label>
  //                           </div>
  //                         </div>
  //                       </div>
  //                     </td>
  //                   </tr>
  //                   <tr>
  //                     <td className="fs-14">Do you have UK Wages Income?</td>
  //                     <td className="fs-14">
  //                       <input className="form-control" type="text" />
  //                     </td>
  //                     <td className="fs-14">
  //                       <input className="form-control" type="text" />
  //                     </td>
  //                   </tr>
  //                   <tr>
  //                     <td className="fs-14">Do you have UK Wages Income?</td>
  //                     <td className="fs-14">
  //                       <div className="d-flex">
  //                         <div className="">
  //                           <div className="form-check">
  //                             <input
  //                               className="form-check-input"
  //                               type="radio"
  //                               name="gridRadios"
  //                               id="gridRadios1"
  //                               defaultValue="option1"
  //                             />
  //                             <label
  //                               className="form-check-label"
  //                               htmlFor="gridRadios1"
  //                             >
  //                               Yes
  //                             </label>
  //                           </div>
  //                         </div>
  //                         <div className="ms-3">
  //                           <div className="form-check">
  //                             <input
  //                               className="form-check-input"
  //                               type="radio"
  //                               name="gridRadios"
  //                               id="gridRadios1"
  //                               defaultValue="option1"
  //                             />
  //                             <label
  //                               className="form-check-label"
  //                               htmlFor="gridRadios1"
  //                             >
  //                               No
  //                             </label>
  //                           </div>
  //                         </div>
  //                       </div>
  //                     </td>
  //                     <td className="fs-14">
  //                       <div className="d-flex">
  //                         <div className="">
  //                           <div className="form-check">
  //                             <input
  //                               className="form-check-input"
  //                               type="radio"
  //                               name="gridRadios"
  //                               id="gridRadios1"
  //                               defaultValue="option1"
  //                             />
  //                             <label
  //                               className="form-check-label"
  //                               htmlFor="gridRadios1"
  //                             >
  //                               Yes
  //                             </label>
  //                           </div>
  //                         </div>
  //                         <div className="ms-3">
  //                           <div className="form-check">
  //                             <input
  //                               className="form-check-input"
  //                               type="radio"
  //                               name="gridRadios"
  //                               id="gridRadios1"
  //                               defaultValue="option1"
  //                             />
  //                             <label
  //                               className="form-check-label"
  //                               htmlFor="gridRadios1"
  //                             >
  //                               No
  //                             </label>
  //                           </div>
  //                         </div>
  //                       </div>
  //                     </td>
  //                   </tr>
  //                 </tbody>
  //               </table>
  //             </div>
  //             <div className="table-resposnsive">
  //               <table className="table table-bordered">
  //                 <thead>
  //                   <tr>
  //                     <th  colSpan="3" className="bg-pink text-center text-white" style={{fontSize:'20px'}}>Quote for Ongoing Services</th>
  //                   </tr>
  //                   <tr>
  //                     <td
  //                       style={{
  //                         background: "#F5F5F5",
  //                         color: "#4E4E4E",
  //                         fontSize: "14px",
  //                       }}
  //                     >
  //                      Service
  //                     </td>
  //                     <td
  //                       style={{
  //                         background: "#F5F5F5",
  //                         color: "#4E4E4E",
  //                         fontSize: "14px",
  //                       }}
  //                     >
  //                      Charge basis
  //                     </td>
  //                     <td
  //                       style={{
  //                         background: "#F5F5F5",
  //                         color: "#4E4E4E",
  //                         fontSize: "14px",
  //                       }}
  //                     >
  //                       Price
  //                     </td>
  //                   </tr>
  //                 </thead>
  //                 <tbody>
  //                   <tr>
  //                     <td className="fs-14">Do you have UK Wages Income?</td>
  //                     <td className="fs-14">
  //                       <div className="d-flex">
  //                         <div className="">
  //                           <div className="form-check">
  //                             <input
  //                               className="form-check-input"
  //                               type="radio"
  //                               name="gridRadios"
  //                               id="gridRadios1"
  //                               defaultValue="option1"
  //                             />
  //                             <label
  //                               className="form-check-label"
  //                               htmlFor="gridRadios1"
  //                             >
  //                               Yes
  //                             </label>
  //                           </div>
  //                         </div>
  //                         <div className="ms-3">
  //                           <div className="form-check">
  //                             <input
  //                               className="form-check-input"
  //                               type="radio"
  //                               name="gridRadios"
  //                               id="gridRadios1"
  //                               defaultValue="option1"
  //                             />
  //                             <label
  //                               className="form-check-label"
  //                               htmlFor="gridRadios1"
  //                             >
  //                               No
  //                             </label>
  //                           </div>
  //                         </div>
  //                       </div>
  //                     </td>
  //                     <td className="fs-14">
  //                       <div className="d-flex">
  //                         <div className="">
  //                           <div className="form-check">
  //                             <input
  //                               className="form-check-input"
  //                               type="radio"
  //                               name="gridRadios"
  //                               id="gridRadios1"
  //                               defaultValue="option1"
  //                             />
  //                             <label
  //                               className="form-check-label"
  //                               htmlFor="gridRadios1"
  //                             >
  //                               Yes
  //                             </label>
  //                           </div>
  //                         </div>
  //                         <div className="ms-3">
  //                           <div className="form-check">
  //                             <input
  //                               className="form-check-input"
  //                               type="radio"
  //                               name="gridRadios"
  //                               id="gridRadios1"
  //                               defaultValue="option1"
  //                             />
  //                             <label
  //                               className="form-check-label"
  //                               htmlFor="gridRadios1"
  //                             >
  //                               No
  //                             </label>
  //                           </div>
  //                         </div>
  //                       </div>
  //                     </td>
  //                   </tr>
  //                   <tr>
  //                     <td className="fs-14">Do you have UK Wages Income?</td>
  //                     <td className="fs-14">
  //                       <input className="form-control" type="text" />
  //                     </td>
  //                     <td className="fs-14">
  //                       <input className="form-control" type="text" />
  //                     </td>
  //                   </tr>
  //                   <tr>
  //                     <td className="fs-14">Do you have UK Wages Income?</td>
  //                     <td className="fs-14">
  //                       <div className="d-flex">
  //                         <div className="">
  //                           <div className="form-check">
  //                             <input
  //                               className="form-check-input"
  //                               type="radio"
  //                               name="gridRadios"
  //                               id="gridRadios1"
  //                               defaultValue="option1"
  //                             />
  //                             <label
  //                               className="form-check-label"
  //                               htmlFor="gridRadios1"
  //                             >
  //                               Yes
  //                             </label>
  //                           </div>
  //                         </div>
  //                         <div className="ms-3">
  //                           <div className="form-check">
  //                             <input
  //                               className="form-check-input"
  //                               type="radio"
  //                               name="gridRadios"
  //                               id="gridRadios1"
  //                               defaultValue="option1"
  //                             />
  //                             <label
  //                               className="form-check-label"
  //                               htmlFor="gridRadios1"
  //                             >
  //                               No
  //                             </label>
  //                           </div>
  //                         </div>
  //                       </div>
  //                     </td>
  //                     <td className="fs-14">
  //                       <div className="d-flex">
  //                         <div className="">
  //                           <div className="form-check">
  //                             <input
  //                               className="form-check-input"
  //                               type="radio"
  //                               name="gridRadios"
  //                               id="gridRadios1"
  //                               defaultValue="option1"
  //                             />
  //                             <label
  //                               className="form-check-label"
  //                               htmlFor="gridRadios1"
  //                             >
  //                               Yes
  //                             </label>
  //                           </div>
  //                         </div>
  //                         <div className="ms-3">
  //                           <div className="form-check">
  //                             <input
  //                               className="form-check-input"
  //                               type="radio"
  //                               name="gridRadios"
  //                               id="gridRadios1"
  //                               defaultValue="option1"
  //                             />
  //                             <label
  //                               className="form-check-label"
  //                               htmlFor="gridRadios1"
  //                             >
  //                               No
  //                             </label>
  //                           </div>
  //                         </div>
  //                       </div>
  //                     </td>
  //                   </tr>
  //                 </tbody>
  //               </table>
  //             </div>
  //           </div>
  //         </div>
  //       </form>
  //       {renderStep()}
  //     </div>
  //   </div>
  // );
  return (
    <div className="">
      <div className="card p-4">
        {renderStep()}
      </div>
    </div>
  );
};

export default MultistepForm;
